export default (dataComp) => {
  const data = Object.keys(dataComp[0]).reduce((result, key, index) => {
    return { ...result, [key]: dataComp[0][key].next, name: dataComp[0][key].name };
  }, {});
  return [data];
};
